import { Box } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode, useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
  scrollOnLoad?: boolean;
  disableScroll?: boolean;
  fullWidth?: boolean;
}

const useStyles = createUseStyles({
  drawerContent: {
    boxSizing: 'border-box',
    padding: '0px 20px',
    maxHeight: '100%',
    '&.scrollable': {
      overflowY: 'auto',
      scrollBehavior: 'smooth',
      scrollbarGutter: 'stable',
      maxHeight: 'none',
    },
    '&.full-width': {
      padding: 0,
    },
  },
});

const DrawerContent: FC<Props> = ({
  children,
  scrollOnLoad = false,
  disableScroll = false,
  fullWidth = false,
}) => {
  const styles = useStyles();

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollOnLoad || !contentRef.current) {
      return;
    }

    contentRef.current.scrollTop = contentRef.current?.scrollHeight || 0;
  }, [contentRef, scrollOnLoad]);

  const compClass = classNames(styles.drawerContent, {
    scrollable: !disableScroll,
    'full-width': fullWidth,
  });

  return (
    <Box className={compClass} ref={contentRef} flexGrow={1}>
      {children}
    </Box>
  );
};

export default DrawerContent;
